// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type SrpStateContextProperties = {
  is_station_filter_applied?: boolean;
  is_transit_switch_on?: boolean;
  is_vendor_filter_applied?: boolean;
  sort_order?: string;
  is_changes_filter_applied?: boolean;
  is_duration_filter_applied?: boolean;
  is_price_filter_applied?: boolean;
  is_arrival_time_filter_applied?: boolean;
  is_departure_time_filter_applied?: boolean;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/srp_state_context/jsonschema/2-0-0';
export const srpStateContextName = 'srp_state_context';
export class SrpStateContext extends BaseTrackingContext<SrpStateContextProperties> {
  constructor(properties: SrpStateContextProperties) {
    super(srpStateContextName, schema, properties);
  }
}
